/* eslint-disable */
import React, {useEffect, useState, memo, useCallback} from 'react'
import axios from 'axios'
import { useSelector } from 'react-redux'
import styled from 'styled-components'
import { Loading } from "../../pages/index";
import { useLocation } from "react-router";
// import {LOG_IN_FAILURE} from "../../reducers/user";

const SmartViewSV = () => {
    const {selectCategory, domain} = useSelector(state => state.initial)
    const {search} = useLocation();
    const isSvp001and002 = search.includes('svp001') || search.includes('svp002')
    const [advData, setAdvData] = useState([])
    const [loading, setLoading] = useState(isSvp001and002)
    const advCode = domain === 'shopping' ? 'svp001' : 'svp002'

    const getAdv = useCallback(() => {
        const url = `${process.env.REACT_APP_API_URL}/front/v3/ad/items/?ad=${advCode}&cateId=${selectCategory}`
        axios.get(url).then(res => {
            setAdvData(res.data.result.ad_result.data || [])
        })
    }, [advCode, selectCategory])

    const attachQueryStringIframeUrl = () => {
        if(search.includes('ad_code')){
            let queryStringAdCode = new URLSearchParams(search).get('ad_code');
            if(advCode === queryStringAdCode){
                let queryStringResult = `?ad_code=${queryStringAdCode}`
                return queryStringResult
            }
        }
        return ''
    }

    useEffect(() => {
        getAdv()
    }, [selectCategory, getAdv])

    return (
        <>
            {search && loading && <FixedStyle><Loading/></FixedStyle>}
            {advData.length > 0 ? (
                <a href="#!" id={`${advCode}_ad`} style={{scrollMarginTop: '100px'}} >
                    <Iframe src={`${process.env.REACT_APP_AD_URL}/${advCode}/${selectCategory}` + attachQueryStringIframeUrl()} title="스마트뷰SV" scrolling="no" height={advData[0].iframe_h}
                     onLoad={() => isSvp001and002 && setTimeout(()=> {setLoading(false)},6000) }/>
                </a>
            ) :
                <></>
            }
        </>
    )
}

const Iframe = styled.iframe`
    width: 100%;
    height: ${props => (props.height + 5) + 'px'};
    border: 0;
    display: block;
    margin: 0 0 10px;
`

const FixedStyle = styled.div`
    position: fixed;
    width: 1000px;
    height: 500px;
    left: 50%;
    transform: translateX(-50%);
    margin: 0px auto;
    bottom: 0px;
    right: 0px;
    opacity: 0.8;
    z-index: 100;
`

export default memo(SmartViewSV)



// WEBPACK FOOTER //
// ./src/estimate_list/components/smartViewSV/index.js